module.exports = __webpack_public_path__ + "src/assets/img/cushion-2.15676de7.png";